import { render, staticRenderFns } from "./dlgHerbal.vue?vue&type=template&id=9f588bfa"
import script from "./dlgHerbal.vue?vue&type=script&lang=js"
export * from "./dlgHerbal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.0_cssnano@5.1.15_postcss@8.5.15__pos_fd10da28d7603cec16d729db226a1fcd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports